import { useComposerStore } from '../hooks/useComposerStore'

import type { SaveErrorsActions } from './saveErrorsSlice'

/** The general (request-level) save errors shown at the top of the composer. */
export const useGeneralSaveErrors = (): string[] =>
  useComposerStore((state) => state.generalSaveErrors)

/**
 * Stable actions to report/clear general save errors. Read together so the
 * save path (which reports on failure and clears on a fresh attempt/success)
 * takes a single dependency. Zustand actions are created once, so each returned
 * reference is stable across renders.
 */
export const useSaveErrorActions = (): Pick<
  SaveErrorsActions,
  'setGeneralSaveErrors' | 'clearGeneralSaveErrors'
> => {
  const setGeneralSaveErrors = useComposerStore(
    (state) => state.setGeneralSaveErrors,
  )
  const clearGeneralSaveErrors = useComposerStore(
    (state) => state.clearGeneralSaveErrors,
  )
  return { setGeneralSaveErrors, clearGeneralSaveErrors }
}
